<template>
  <div class="column is-2">
    <router-link :to="to" class="series-item">
      <img :src="rootPath + item.ch" :alt="item.longtitle" />
      <strong class="has-text-black">{{ item.pagetitle }}</strong>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    item: Object
  },
  computed: {
    rootPath() {
      return `${process.env.VUE_APP_ROOT_PATH}`;
    },
    to() {
      return `/series/${this.item.id}`;
    }
  }
};
</script>

<style lang="scss">
.series-item {
  display: block;
  text-align: center;
  transition: all 0.3s ease;
  img {
    border: 2px solid transparent;
    transition: all 0.3s ease;
  }
  &:hover,
  &:focus {
    color: hsl(141, 84%, 27%);
    img {
      border: 2px solid hsl(141, 71%, 48%);
    }
  }
}
</style>
